"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var border = {
  radius: {
    "default": 3,
    medium: 5
  },
  solid: {
    "default": "1px solid",
    medium: "3px solid"
  }
};
exports["default"] = border;